<template>
  <default-dialog @input="closeForm()" :value="enabled" title="Criar capítulo">
    <template slot="rightButton">
      <v-btn @click="submit" text>Salvar</v-btn>
    </template>
    <v-form ref="form" v-model="valid" style="margin-top: 19px;">
      <v-text-field
        v-model="title"
        required
        :error-messages="titleErrorMessage"
        :counter="titleMaxLength"
        :rules="[formRules.required, formRules.title]"
        :label="'Título'"
        :placeholder="'Digite o título do capítulo'"
      />
      <v-textarea
        v-model="description"
        auto-grow
        xs12
        :rules="[formRules.description]"
        :counter="descriptionMaxLength"
        :label="'Descrição breve'"
        :placeholder="'Descreva o capítulo'"
        :hide-details="'auto'"
        :color="'primary'"
        :rows="'1'"
      />
      <v-autocomplete
        v-model="icon"
        cache-items
        required
        :rules="[formRules.required]"
        :hide-details="'auto'"
        :class="'my-3'"
        :key="icon"
        :items="icons"
        :no-data-text="'Nenhum ícone encontrado...'"
        :label="'Ícone'"
        :prepend-icon="icon"
      >
        <template v-slot:item="{ item }">
          <v-list-item-avatar>
            <v-icon>{{item}}</v-icon>
          </v-list-item-avatar>
          <v-list-item-title>{{item}}</v-list-item-title>
        </template>
      </v-autocomplete>
    </v-form>
  </default-dialog>
</template>

<script>
import DefaultDialog from "@/components/dialogs/Default";
import { maxLength } from '@/utils/maxLength'
import icons from "@/utils/icons.js";
import FormRules from "@/utils/formRules.js";

export default {
  components: { DefaultDialog },
  mixins: [FormRules],
  props: {
    enabled: Boolean,
    currentChapters: Array
  },

  data: () => ({
    icons,
    valid: true,
    title: "",
    icon: "",
    description: "",
    titleMaxLength: maxLength.title,
    descriptionMaxLength: maxLength.description,
    chapterAlreadyExistsError: "Já existe um capítulo com esse título"
  }),
  computed: {
    titleErrorMessage() {
      const filter = chapter => chapter.title === this.title;
      const chaptersWithSameTitle = this.currentChapters.filter(filter);
      const thisIsANewChapter = chaptersWithSameTitle.length === 0;
      const titleErrorMessage = thisIsANewChapter
        ? ""
        : this.chapterAlreadyExistsError;
      return titleErrorMessage;
    }
  },

  methods: {
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    submit() {
      this.validate();
      if (this.valid) {
        const { title, description, icon } = this;
        const newChapter = { title, description, icon };
        this.$emit("submit", newChapter);
        this.closeForm();
      }
    },

    closeForm() {
      this.reset();
      this.$emit("closed");
    }
  }
};
</script>